import { Form } from "@/components/core/forms/form.tsx";
import { useModal } from "@/components/core/modals/use-modal";
import { caseDeletionQueryOptions } from "@/features/case-evaluation/api/queries/acitivities-query";
import { caseCollaboratorsQueryOptions, useCaseCollaboratorCanPostMutation } from "@/features/case-record/api/queries/case-collaborator-query";
import { formatDate } from "@/utils/format-date";
import { IconCheck, IconX } from "@tabler/icons-react";
import { useQuery } from "@tanstack/react-query";
import { useForm } from "react-hook-form";

export default function CaseDeletionHistoryModal({ caseId }: { caseId: string }) {
	const modal = useModal();

	const form = useForm({
		defaultValues: {},
	});

	const deletionQuery = useQuery(
		caseDeletionQueryOptions({
			id: caseId,
		}),
	);

	const deletions = deletionQuery.data?.data;
	console.log(deletions, "deletions");

	return (
		<Form {...form}>
			<form className="w-full">
				<div className="flex flex-col w-full rounded-md border border-border/50">
					<table className="text-sm">
						<thead>
							<tr className="border-b-2 border-border/50">
								<th className="w-[220px] text-left text-foreground-dark p-3">Title</th>
								<th className=" text-left text-foreground-dark p-3">Reason</th>
								<th className=" text-left text-foreground-dark p-3">Deleted By</th>
								<th className=" text-left text-foreground-dark p-3">Date Deleted</th>
							</tr>
						</thead>
						<tbody>
							{deletions?.map((deletion, index) => (
								<tr key={index} className="border-b border-border/50 last:border-b-0">
									<td className="px-3 py-2">{deletion.activity ? deletion.activity.activity : ""}</td>
									<td className="px-3 py-2">{deletion.reason}</td>
									<td className="px-3 py-2">{deletion.user.full_name}</td>
									<td className="px-3 py-2">{deletion.created_at ? formatDate(deletion.created_at) : ""}</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</form>
		</Form>
	);
}
